import Vue from 'vue'
import mitt from 'mitt'
import UiToastHolder from '../Toast/ToastHolder/ToastHolder.vue'
const emitter = mitt()

const eventBus = {
    $on: (...args) => emitter.on(...args),
    $off: (...args) => emitter.off(...args),
    $emit: (...args) => emitter.emit(...args),
    $once: (type, handler) => {
        const fn = (...args) => {
            emitter.off(type, fn)
            handler(...args)
        }
        emitter.on(type, fn)
    },
}

const mountToastHolder = (systemMessage = false) => {
    const holderId = systemMessage
        ? 'vue-system-message-holder'
        : 'vue-toast-holder'

    const toastHolder = document.querySelector(`#${holderId}`)

    //If toast holder already exists, make sure it's the last child in vue main.
    if (toastHolder) {
        if (document.body.lastElementChild !== toastHolder) {
            document.body.appendChild(toastHolder)
        }
        return
    }

    const mountPoint = document.createElement('div')
    document.body.appendChild(mountPoint)

    new Vue({
        render: (h) =>
            h(
                'div',
                {
                    attrs: {
                        id: holderId,
                    },
                    class: 'new-ui vue-ui-component-wrapper',
                },
                [
                    h(UiToastHolder, {
                        props: {
                            systemMessage,
                        },
                    }),
                ]
            ),
    }).$mount(mountPoint)
}

const toastMessage = (options = {}) => {
    const systemMessage = options.systemMessage === true

    mountToastHolder(systemMessage)

    Vue.nextTick(() => {
        eventBus.$emit(
            systemMessage ? 'system-message:new' : 'toast:new',
            options
        )
    })
}

const clearAllToasts = () => {
    eventBus.$emit('toast:clearAll')
    eventBus.$emit('system-message:clearAll')
}

const clearSystemMessages = () => {
    eventBus.$emit('system-message:clearAll')
}

const toastPlugin = {}

toastPlugin.install = (Vue) => {
    Vue.prototype.$toast = (options) => {
        toastMessage(options)
    }
    Vue.prototype.$clearAllToasts = () => {
        clearAllToasts()
    }
    Vue.prototype.$clearSystemMessages = () => {
        clearSystemMessages()
    }
}

export {
    eventBus,
    toastMessage,
    clearAllToasts,
    clearSystemMessages,
    toastPlugin,
}
